import React, { useState, useEffect } from "react";
import { Box, Container, makeStyles, Typography } from "@material-ui/core";
import Page from "src/components/Page";
import Form from "./Form";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import {
  apiEndpoints,
  apiPostRequest,
  apiPutRequest,
  apiGetByIdRequest,
} from "src/utils/api/api";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import { kmMessages } from "src/constant/Messages";
import KmPageTitle from "src/components/layout/KmPageTitle"

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  title: {
    marginLeft: theme.spacing(3),
  },
}));

const FunctionForm = ({
  setLogoutUser,
  enableGlobalLoader,
  disableGlobalLoader,
  displaySnackbar,
  ...rest
}) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { entryId } = useParams();
  const [funct, setFunct] = useState({"name": ""});

  const editMode = rest.kmaction === 'edit';

  let pageTitle =
    rest.kmaction === "new"
      ? "Nowa funkcja"
      : "Edycja funkcję";

  useEffect(() => {
    if (editMode) {
      enableGlobalLoader();
      apiGetByIdRequest(
        apiEndpoints.getFunctionDetails.path,
        entryId,
        true
      )
        .then((data) => {
          disableGlobalLoader();
          setFunct(data);
        })
        .catch((error) => {
          disableGlobalLoader();
        });
    }
    return () => {};
  }, []);

  const onSubmit = (values,roleValue) => {
    enableGlobalLoader();

    if (editMode) {
      apiPutRequest(
        apiEndpoints.updateFunction.path,
        {
          id: entryId,
          name: values.name,
          role: roleValue
        },
        true
      )
        .then((data) => {
          disableGlobalLoader();
          navigate("/administracja/slowniki/2");
        })
        .catch((error) => {
          disableGlobalLoader();
          if (error.response && error.response.status === 401) {
            setLogoutUser();
          } else if (error.response.status === 400 && error.response.data) {
            if (error.response.data.code === "ERROR_FUNCTION_WITH_ROLE_EXISTS") {
              displaySnackbar({
                isOpen: true,
                severity: "error",
                autoHideDuration: 8000,
                message: kmMessages.error.admin.function_role_exist,
              });
            }
          }
        });
    } else {
      apiPostRequest(
        apiEndpoints.addFunction.path,
        {
          name: values.name,
          role: roleValue
        },
        true
      )
        .then((data) => {
          disableGlobalLoader();
          navigate("/administracja/slowniki/2");
        })
        .catch((error) => {
          disableGlobalLoader();
          if (error.response && error.response.status === 401) {
            setLogoutUser();
          } else if (error.response.status === 400 && error.response.data) {
            if (error.response.data.code === "ERROR_FUNCTION_WITH_ROLE_EXISTS") {
              displaySnackbar({
                isOpen: true,
                severity: "error",
                autoHideDuration: 8000,
                message: kmMessages.error.admin.function_role_exist,
              });
            }
          }
        });
    }
  };

  return (
    <Page className={classes.root} title={pageTitle}>
      <KmPageTitle>
        {pageTitle}
      </KmPageTitle>

      <Container maxWidth={false}>
        <Box mt={3}>
          <Form onSubmit={onSubmit} funct={funct} editMode={editMode}/>
        </Box>
      </Container>
    </Page>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setLogoutUser: () => dispatch(actions.setLogoutUser()),
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
  displaySnackbar: (snackBarParameters) =>
    dispatch(actions.displaySnackbar(snackBarParameters)),
});

export default connect(null, mapDispatchToProps)(FunctionForm);
